// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: white !important;
  display: flex;
  flex-direction: column;
 
 &::-webkit-scrollbar {
  display: none;
 }
}

.container_AwyzD {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100vh;
  overflow: auto;
  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);
  #logo__GKkz {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 30px;
    P {
      font-size: clamp(30px, 12vw, 60px);

      color: var(--_2-color);
      margin: 0;
      span {
        font-weight: bolder;
      }
    }
  }
  #LogoGPT_sWh19 {
    width: 30%;
  }
}

.content_noVHM {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-align: center;
  padding: 20px 10px 0px;

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: #107d63;
    font-weight: bold;
    text-decoration: none;
  }

  button {
    background-color: var(--white-color);
    border: 1px solid var(--d9-background);
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
    width: 100%;

    img {
      height: 20px;
      width: 20px;
    }


  }
  button:hover {
    background-color: var(--fa-background);
  }
  .safety_Qwf4A,
  button {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    padding: 5px 40px;
  }

  .policy_uGvK0 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btnContainer_pUes_ {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100%;
    max-width: 400px;
    a {
      background-color: var(--fa-background);
      border: 1px solid var(--d9-background);
      border-radius: 5px;
      display: flex;
      gap: 10px;
      justify-content: center;
      align-items: center;
      padding: 5px 40px;
      cursor: pointer;
    }
  }
}

@media (max-width: 768px) {
  .content_noVHM {
    #logo__GKkz {
      width: 50%;
    }
    .policy_uGvK0 {
      font-size: 15px;
      padding: 10px;
      display: block;
      margin: 0;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/FreeTrial/FreeTrial.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,aAAa;EACb,sBAAsB;;CAEvB;EACC,aAAa;CACd;AACD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8DAA8D;EAC9D;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB;MACE,kCAAkC;;MAElC,sBAAsB;MACtB,SAAS;MACT;QACE,mBAAmB;MACrB;IACF;EACF;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sBAAsB;;EAEtB;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,oCAAoC;IACpC,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;;IAEX;MACE,YAAY;MACZ,WAAW;IACb;;;EAGF;EACA;IACE,sCAAsC;EACxC;EACA;;IAEE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB;MACE,sCAAsC;MACtC,sCAAsC;MACtC,kBAAkB;MAClB,aAAa;MACb,SAAS;MACT,uBAAuB;MACvB,mBAAmB;MACnB,iBAAiB;MACjB,eAAe;IACjB;EACF;AACF;;AAEA;EACE;IACE;MACE,UAAU;IACZ;IACA;MACE,eAAe;MACf,aAAa;MACb,cAAc;MACd,SAAS;IACX;EACF;AACF","sourcesContent":["body {\n  background-color: white !important;\n  display: flex;\n  flex-direction: column;\n \n &::-webkit-scrollbar {\n  display: none;\n }\n}\n\n.container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  overflow: auto;\n  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);\n  #logo {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 30px;\n    P {\n      font-size: clamp(30px, 12vw, 60px);\n\n      color: var(--_2-color);\n      margin: 0;\n      span {\n        font-weight: bolder;\n      }\n    }\n  }\n  #LogoGPT {\n    width: 30%;\n  }\n}\n\n.content {\n  margin-top: 50px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  text-align: center;\n  padding: 20px 10px 0px;\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  a {\n    color: #107d63;\n    font-weight: bold;\n    text-decoration: none;\n  }\n\n  button {\n    background-color: var(--white-color);\n    border: 1px solid var(--d9-background);\n    border-radius: 5px;\n    cursor: pointer;\n    height: 40px;\n    width: 100%;\n\n    img {\n      height: 20px;\n      width: 20px;\n    }\n\n\n  }\n  button:hover {\n    background-color: var(--fa-background);\n  }\n  .safety,\n  button {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n    padding: 5px 40px;\n  }\n\n  .policy {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .btnContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    width: 100%;\n    max-width: 400px;\n    a {\n      background-color: var(--fa-background);\n      border: 1px solid var(--d9-background);\n      border-radius: 5px;\n      display: flex;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      padding: 5px 40px;\n      cursor: pointer;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .content {\n    #logo {\n      width: 50%;\n    }\n    .policy {\n      font-size: 15px;\n      padding: 10px;\n      display: block;\n      margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_AwyzD`,
	"logo": `logo__GKkz`,
	"LogoGPT": `LogoGPT_sWh19`,
	"content": `content_noVHM`,
	"safety": `safety_Qwf4A`,
	"policy": `policy_uGvK0`,
	"btnContainer": `btnContainer_pUes_`
};
export default ___CSS_LOADER_EXPORT___;
